import ThemeConfig from '@assets/theme';
import { LinearProgress } from '@material-ui/core';
import { CompanyProfile } from '@pages/CompanyProfile';
import ErrorBoundary from '@settings/ErrorBoundary';
import ErrorController from '@settings/ErrorController';
import { SnackbarProvider } from 'notistack';
import React, { Suspense } from 'react';

function PointCompanyProfile() {
  return (
    <ThemeConfig containerId="onlog-company-profile-container">
      <Suspense fallback={<LinearProgress />}>
        <SnackbarProvider maxSnack={10} preventDuplicate={true} autoHideDuration={3000}>
          <ErrorBoundary needJSX={true}>
            <CompanyProfile />
            <ErrorController />
          </ErrorBoundary>
        </SnackbarProvider>
      </Suspense>
    </ThemeConfig>
  );
}

export default PointCompanyProfile;
